import React from 'react';
import { Checkbox } from 'semantic-ui-react';
import { isChecked } from '@/utils/resultsHelper';
import { camelConverter } from '../helper';

const FormToggle = ({
  disabled,
  field,
  onChange,
  text,
}) => (
  <Checkbox
    checked={isChecked(text)}
    className="aridhia-form-toggle"
    disabled={disabled}
    id={camelConverter(field.name, '_')}
    label={field.label}
    onClick={disabled ? undefined : () => onChange(!isChecked(text))}
    toggle
  />
);

export default FormToggle;
